<template>
  <v-container id="suspects" class="bebas" pa-0>
    <transition-group
      appear
      tag="ul"
      name="staggered-fade"
      class="list-container"
      :css="false"
      v-on:enter="enter"
      v-on:leave="leave"
    >
      <li
        v-if="!showSuspectPage"
        class="list-item"
        :class="{ height: listHeight }"
        v-for="(k, i) in numOfSuspects + 1"
        :key="i + 1"
        v-bind:data-index="i"
      >
        <v-img
          :src="i < 4 ? folders[i] : folders[i - 4]"
          position="top center"
          :height="listHeight"
        >
          <div
            id="filtered-suspect"
            v-if="filteredSuspectList[i]"
            @click="
              filteredSuspectList[i].active
                ? setOpenSuspect(filteredSuspectList[i].id)
                : ''
            "
          >
            <div class="pa-2">
              <v-avatar
                class="mr-1"
                v-if="suspectHasActiveClues(filteredSuspectList[i])"
                color="#AE250A"
                size="18"
              >
                <span class="white--text subheading font-weight-medium">!</span>
              </v-avatar>
              <v-avatar
                class="mr-1"
                v-if="!suspectHasActiveClues(filteredSuspectList[i])"
                size="18"
              ></v-avatar>
              <span>{{
                filteredSuspectList[i].active
                  ? filteredSuspectList[i].name
                  : "? ? ? ? ?"
              }}</span>
            </div>
            <div class="suspect-open-action-button">
              <v-avatar v-if="filteredSuspectList[i].active" size="35">
                <v-icon color="black" size="30">add</v-icon>
              </v-avatar>
              <v-avatar v-else size="20" tile>
                <v-img :src="questionmark" contain position="top center" />
              </v-avatar>
            </div>
          </div>
          <div v-else>
            <div class="pa-2" :style="{ opacity: '.25' }">
              <v-avatar class="mr-1" size="20"></v-avatar>

              <span>CLASSIFIED</span>
            </div>
          </div>
        </v-img>
      </li>
    </transition-group>
    <v-dialog
      id="clue-dialog"
      content-class="hint-dialog"
      persistent
      v-model="clueDialog"
    >
      <v-card color="rgba(0,0,0, 0.7)" class="border-radius-15">
        <v-container>
          <v-container text-xs-center>
            <p class="fs-24 white--text bebas">{{ openActiveClue.clue }}</p>
          </v-container>
          <v-layout row>
            <v-flex d-flex>
              <div />
              <div>
                <v-btn
                  class="border-radius-5 border-button"
                  key="`hint-answer`"
                  outline
                  block
                  large
                  color="white"
                  @click="clueDialog = false"
                  >got it</v-btn
                >
              </div>
              <div />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <div id="viewer-container">
      <img id="image" :src="suspectEnlargedMugshot" width="0" height="0" />
      <v-snackbar id="snackbar" :value="showSnackbar" bottom :timeout="0">
        <div class="text-xs-center">
          Zoom in and Out to analyze the mugshot for more information
        </div>
      </v-snackbar>
    </div>
    <transition
      v-on:before-enter="beforeSuspectPageEnter"
      v-on:enter="suspectPageEnter"
      v-on:leave="suspectPageLeave"
    >
      <div id="active-suspect-container" v-if="showSuspectPage">
        <v-container id="active-suspect-content" pa-0>
          <v-img :src="suspectViewUrl" contain>
            <v-container fluid>
              <v-layout row justify-center>
                <v-flex xs12 align-end flexbox></v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs-3>
                  <div
                    class="suspect-close-button"
                    @click.stop="showSuspectPage = !showSuspectPage"
                  >
                    <img :src="closeButton" height="25px" />
                  </div>
                </v-flex>
              </v-layout>
              <v-container
                id="suspect-hints-container"
                class="text-uppercase"
                py-2
                px-3
              >
                <div
                  v-for="(clue, i) in openSuspect.clues"
                  :key="`clue-${i + 1}`"
                  @click="clue.active ? openClue(clue) : ''"
                >
                  <div class="px-1 py-0 my-2" :class="ifActiveClue(clue)">
                    <v-avatar
                      class="mr-2"
                      v-if="clue.active && !clue.read"
                      color="#AE250A"
                      size="18"
                    >
                      <span class="white--text subheading font-weight-medium"
                        >!</span
                      >
                    </v-avatar>
                    <v-avatar
                      class="mr-2"
                      v-else-if="clue.active && clue.read"
                      size="18"
                    >
                      <v-icon color="green" size="22">check_circle</v-icon>
                    </v-avatar>
                    <v-avatar class="mr-2" v-else size="20"></v-avatar>
                    <span
                      class="bebas subheading"
                      :style="{ opacity: clue.active ? '1' : '.25' }"
                      >{{ `Clue #${i + 1}` }}</span
                    >
                  </div>
                </div>
              </v-container>
              <v-container
                id="expand-button-container"
                class="text-uppercase"
                py-2
                px-3
              >
                <v-btn @click="show" flat style="border: 3px solid black"
                  >Enlarge Mugshot</v-btn
                >
              </v-container>
            </v-container>
          </v-img>
        </v-container>
      </div>
    </transition>
  </v-container>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "viewerjs";
import suspectBackgroundImage from "@/assets/nav_bottom_folder.png";
import Folder1 from "@/assets/suspects/folder-1.png";
import Folder2 from "@/assets/suspects/folder-2.png";
import Folder3 from "@/assets/suspects/folder-3.png";
import Folder4 from "@/assets/suspects/folder-4.png";
import Velocity from "velocity-animate";
import QuestionMark from "@/assets/suspects/questionmark.png";
import backButtonBlk from "@/assets/directions/back_button-blk.png";

import closeButton from "@/assets/close_x_icon.png";

export default {
  name: "suspects",
  data() {
    return {
      showSnackbar: false,
      showImage: false,
      mugshot: null,
      enlargedMugshotDialog: false,
      suspectBackgroundImage,
      openSuspectName: "",
      openSuspectId: null,
      showSuspectPage: false,
      openActiveClue: {},
      closeButton,
      suspectDialog: false,
      clueDialog: false,
      suspects: this.$store.getters.suspects,
      numOfSuspects: this.$store.getters.suspects.length,
      folders: [Folder1, Folder2, Folder3, Folder4],
      questionmark: QuestionMark,
      listHeight: null,
      backButtonBlk: backButtonBlk,
    };
  },
  computed: {
    imageHeight() {
      var numOfMarginsNeeded = this.numOfSuspects + 1;
      var marginHeight = numOfMarginsNeeded * 15;
      var containerHeight = window.innerHeight - marginHeight - 56;
      var heightPerCard = Math.floor(containerHeight / this.numOfSuspects);
      var imageHeight = heightPerCard;
      return Math.floor(imageHeight) + "px";
    },
    suspectViewUrl() {
      return this.openSuspect.view.url;
    },
    suspectEnlargedMugshot() {
      return this.openSuspect ? this.openSuspect.enlargedMugshot.url : "";
    },
    openSuspect() {
      return this.openSuspectId !== ""
        ? this.suspects.find((s) => s.id === this.openSuspectId)
        : null;
    },
    containerHeight() {
      var containerHeight = window.innerHeight - 56;
      return containerHeight;
    },
    filteredSuspectList() {
      return this.suspects.sort((susA, susB) => {
        if (susA.active && susB.active) {
          return 0;
        }
        if (!susA.active && susB.active) {
          return 1;
        }
        if (susA.active && !susB.active) {
          return -1;
        }
        if (!susA.active && !susB.active) {
          return 0;
        }
      });
    },
  },
  mounted() {
    this.calculateListItemHeight();
  },
  methods: {
    show() {
      // var viewerContainer = document.getElementById("viewer-container");
      // var imgElement = document.createElement("IMG");
      // imgElement.src = this.suspectEnlargedMugshot;
      // imgElement.alt = "testing";
      // imgElement.id = "image";
      // imgElement.height = 0;
      // imgElement.width = 0;
      // viewerContainer.appendChild(imgElement);
      var image = document.getElementById("image");
      var that = this;
      image.addEventListener("hidden", function() {
        viewer.destroy();
        that.showSnackbar = false;
      });
      const viewer = new Viewer(image, {
        navbar: false,
        title: false,
        toolbar: false,
        rotatable: false,
        scalable: false,
        show: (i) => {
          console.log(i);
        },
      });
      viewer.show();
      this.showSnackbar = true;
    },
    calculateListItemHeight() {
      var listHeight =
        this.$store.getters.appInnerHeight / (this.numOfSuspects + 2);
      listHeight = listHeight + 15 + "px";
      this.listHeight = listHeight;
    },
    ifActiveClue(clue) {
      return clue.active ? "quiz-button-border" : "";
    },
    openClue(clue) {
      if (!clue.read) {
        this.$store.dispatch("userReadClue", {
          clueId: clue.id,
          suspectId: this.openSuspectId,
        });
      }
      this.openActiveClue = clue;
      this.clueDialog = true;
    },
    setOpenSuspectName(name) {
      var suspect = this.suspects.find((s) => s.name === name);
      if (suspect.active) {
        this.openSuspectName = name;
        this.showSuspectPage = true;
      }
    },
    setOpenSuspect(id) {
      var suspect = this.suspects.find((s) => s.id === id);
      if (suspect.active) {
        this.openSuspectId = id;
        this.showSuspectPage = true;
      }
    },
    suspectHasActiveClues(s) {
      return s.clues.filter((c) => c.active && !c.read).length > 0;
    },
    getSuspectActiveCluesNumber(clues) {
      return clues.filter((c) => c.active && !c.read).length;
    },
    suspectActiveClueNumber(clues) {
      return clues.filter((c) => c.active && !c.read).length > 0 ? true : false;
    },
    beforeSuspectPageEnter: function(el) {
      el.style.opacity = 1;
      el.style.position = "relative";
      el.style.bottom = "-700px";
    },
    suspectPageEnter: function(el, done) {
      Velocity(
        el,
        {
          opacity: 1,
          bottom: 0,
        },
        {
          duration: 450,
        },
        {
          complete: done,
        }
      );
    },
    suspectPageLeave: function(el, done) {
      Velocity(
        el,
        {
          opacity: 1,
          top: "1200px",
          bottom: "-300px",
        },
        {
          duration: 250,
        },
        {
          complete: done,
        }
      );
    },
    enter: function(el, done) {
      var delay = el.dataset.index * 80;
      setTimeout(function() {
        Velocity(
          el,
          {
            opacity: 1,
            marginBottom: "-55px",
          },
          {
            complete: done,
          }
        );
      }, delay);
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 50;
      setTimeout(function() {
        Velocity(
          el,
          {
            opacity: 0,
            height: 0,
          },
          {
            complete: done,
          }
        );
      }, delay);
    },
  },
};
</script>

<style scoped>
#image {
  position: absolute;
}
#snackbar {
  z-index: 15000;
}
#suspects {
  background-image: url("../assets/backgrounds/brick-blk.png");
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  position: relative;
  font-family: "1942";
  font-weight: "bold";
}

#suspects-container {
  position: absolute;
  bottom: 125px;
  background-color: Transparent;
  width: 100%;
  font-family: "1942";
  font-weight: "bold";
}

#suspect-hints-container {
  position: absolute;
  bottom: 40px;
  left: 20px;
  width: 40%;
  height: 50%;
}

#expand-button-container {
  position: absolute;
  bottom: 40px;
  right: 20px;
  width: 40%;
  height: 10%;
}

#card-background {
  background-color: Transparent;
  margin-bottom: -55px;
}

#clue-dialog {
  font-family: "BebasNeue-Regular";
}

.quiz-button-border {
  border: 3px solid black;
}

#active-suspect-container {
  height: 100%;
}

#active-suspect-content {
  position: absolute;
  bottom: 80px;
}

.suspect-open-action-button {
  width: 100%;
  position: relative;
}

.suspect-open-action-button .v-avatar {
  position: absolute;
  right: 15px;
  top: -12px;
}

.suspect-open-action-button .v-avatar .v-image {
  margin-right: 15px;
}

.suspect-close-button {
  position: absolute;
  right: 15px;
  padding: 10px 10px;
}

.list-container {
  position: absolute;
  bottom: 135px;
  list-style: none;
  padding-left: 0;
  width: 100%;
}

.list-item {
  font-family: "Irresponsible-Direction";
  letter-spacing: 1.2px;
  font-size: 16px;
  width: 100%;
  margin-bottom: -140px;
  opacity: 0;
}

.list-item .list-button {
  padding-right: 5px;
}

.fan-up-enter-active {
  transition: all 1000ms;
}

.fan-up-enter {
  margin-bottom: -125px;
}

.fan-up-enter-to {
  margin-bottom: -50px;
}
</style>
